import { render, staticRenderFns } from "./classroomTable.vue?vue&type=template&id=e1b1253e&scoped=true"
import script from "./classroomTable.vue?vue&type=script&lang=js"
export * from "./classroomTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b1253e",
  null
  
)

export default component.exports